__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@portal/workspace";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@codat/analytics", "2.4.1", () => (Promise.all([__webpack_require__.e(670), __webpack_require__.e(297), __webpack_require__.e(335)]).then(() => (() => (__webpack_require__(58670))))));
			register("@codat/client-cookie-manager", "3.16.1", () => (Promise.all([__webpack_require__.e(332), __webpack_require__.e(297)]).then(() => (() => (__webpack_require__(4332))))));
			register("@tanstack/react-query", "5.65.1", () => (Promise.all([__webpack_require__.e(194), __webpack_require__.e(297), __webpack_require__.e(70)]).then(() => (() => (__webpack_require__(30194))))));
			register("i18next", "25.8.13", () => (__webpack_require__.e(652).then(() => (() => (__webpack_require__(11652))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(143), __webpack_require__.e(297)]).then(() => (() => (__webpack_require__(8143))))));
			register("react-i18next", "16.5.4", () => (Promise.all([__webpack_require__.e(53), __webpack_require__.e(297), __webpack_require__.e(310)]).then(() => (() => (__webpack_require__(93053))))));
			register("react-router-dom-v5-compat", "6.23.0", () => (Promise.all([__webpack_require__.e(789), __webpack_require__.e(297), __webpack_require__.e(247)]).then(() => (() => (__webpack_require__(87789))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(404), __webpack_require__.e(297)]).then(() => (() => (__webpack_require__(30404))))));
			register("react", "18.3.1", () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))));
			initExternal(18077);
			initExternal(49336);
			initExternal(72209);
			initExternal(78676);
			initExternal(47659);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};